import React from "react";
//#region src/AccountForm/AccountFormCinderblocks/NamelessAccountContext.tsx
var NamelessAccountContext = React.createContext({
	shouldRegisterOnEmailSubmit: false,
	onPasswordFormLoad: void 0,
	onAccountUpdate: void 0,
	emailRegistrationError: ""
});
var NamelessAccountContextProvider = ({ shouldRegisterOnEmailSubmit, onPasswordFormLoad, onAccountUpdate, emailRegistrationError, children }) => {
	return /* @__PURE__ */ React.createElement(NamelessAccountContext.Provider, { value: {
		shouldRegisterOnEmailSubmit,
		onPasswordFormLoad,
		onAccountUpdate,
		emailRegistrationError
	} }, children);
};
//#endregion
export { NamelessAccountContext, NamelessAccountContextProvider };

